import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const EVICTION_TERMINATION_SOURCES_A = [
  {
    sourceId: "eviction-source-landlord-ending",
    topicId: "eviction-termination",
    title: "Landlord ending a tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/landlord-ending-a-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 모든 lease type의 specific ground, written notice·termination information statement·supporting documents와 NCAT termination order 절차를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW landlord termination grounds, notice requirements와 supporting evidence",
    followUp: "notice ground별 current documents, prohibited re-letting period와 declaration requirements를 확인",
  },
  {
    sourceId: "eviction-source-notice-periods",
    topicId: "eviction-termination",
    title: "Minimum notice periods for ending a residential tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/minimum-notice-periods-for-ending-a-residential-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 notice table에서 ground, fixed·periodic agreement, agreement length와 notice sender별 current minimum periods·early exit를 확인",
    reviewStatus: "live_verified",
    claimScope: "NSW tenancy termination의 ground별 minimum notice periods",
    followUp: "notice 수령일 기준 current table, service days와 fixed-term exceptions를 재확인",
  },
  {
    sourceId: "eviction-source-giving-notice",
    topicId: "eviction-termination",
    title: "Giving notice to end a residential tenancy",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/housing-and-construction/rules/giving-notice-to-end-a-residential-tenancy",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 본문에서 notice의 writing·signature·date·address·termination date·ground, information statement와 lawful service requirements를 확인",
    reviewStatus: "live_verified",
    claimScope: "termination notice 형식·내용·service와 accompanying documents",
    followUp: "실제 delivery method, deemed-service date와 current template를 notice 검토 시 확인",
  },
  {
    sourceId: "eviction-source-law-changes",
    topicId: "eviction-termination",
    title: "Changes to rental laws",
    publisher: "NSW Fair Trading",
    url: "https://www.nsw.gov.au/departments-and-agencies/fair-trading/news/changes-to-rental-laws",
    trust: 5,
    jurisdiction: "nsw",
    checkedAt: "2026-07-17",
    verificationMethod:
      "NSW Government 공식 update에서 19 May 2025 no-grounds termination 종료, genuine reason·supporting documents와 false-ground penalties를 확인",
    reviewStatus: "live_verified",
    claimScope: "2024-2026 NSW rental-law reforms 중 tenancy ending changes",
    followUp: "notice가 19 May 2025 전후 언제 발행됐는지와 transitional rule을 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of EVICTION_TERMINATION_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
